
import {hasWindow} from 'utils/functions';

// The iOS app tags every in-app WebView's User-Agent with this
// substring. It's the one signal we gate all app-only behavior on.
const APP_UA_MARKER = 'BodySpecApp';

export const isAppWebView = (): boolean =>
	hasWindow() && navigator.userAgent.includes(APP_UA_MARKER);
